import { Trans } from "@lingui/macro";
import React from "react";
import * as styles from "./ExchangeRateDisclaimer.module.scss";

const ExchangeRateDisclaimer: React.FC = () => {
  return (
    <div className={styles.exchangeRateDisclaimer}>
      <Trans id="exchange-rate-disclaimer">
        Favourable CAD/USD exchange rate applies (1.25)
      </Trans>
    </div>
  );
};

export default ExchangeRateDisclaimer;
